import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function AddPlaylist() {
  const [url, setUrl] = useState('');
  const [file, setFile] = useState(null);
  const [xtream, setXtream] = useState({ host: '', username: '', password: '' });
  const navigate = useNavigate();

  const handleAddUrl = async () => {
    if (!url) return alert('Enter a valid URL');
    let type = 'm3u';

    try {
      const res = await fetch(url);
      const text = await res.text();

      try {
        JSON.parse(text); // if it's valid JSON
        type = 'json';
      } catch {
        type = 'm3u';
      }
    } catch {
      return alert('Invalid or inaccessible URL');
    }

    const playlists = JSON.parse(localStorage.getItem('custom_playlists') || '[]');
    playlists.push({ name: `Custom ${type.toUpperCase()}`, url, type });
    localStorage.setItem('custom_playlists', JSON.stringify(playlists));
    navigate('/');
  };

  const handleFile = (e) => {
    const reader = new FileReader();
    reader.onload = () => {
      const content = reader.result;
      let type = 'm3u';

      try {
        JSON.parse(content);
        type = 'json';
      } catch {
        type = 'm3u';
      }

      const playlists = JSON.parse(localStorage.getItem('custom_playlists') || '[]');
      playlists.push({ name: file.name, url: content, type });
      localStorage.setItem('custom_playlists', JSON.stringify(playlists));
      navigate('/');
    };

    if (e.target.files[0]) {
      setFile(e.target.files[0]);
      reader.readAsText(e.target.files[0]);
    }
  };

  const handleXtream = () => {
    const { host, username, password } = xtream;
    if (!host || !username || !password) return alert('Fill all Xtream fields');
    const xtreamUrl = `${host}/get.php?username=${username}&password=${password}&type=m3u_plus&output=mpegts`;

    const playlists = JSON.parse(localStorage.getItem('custom_playlists') || '[]');
    playlists.push({ name: `Xtream - ${username}`, url: xtreamUrl, type: 'm3u' });
    localStorage.setItem('custom_playlists', JSON.stringify(playlists));
    navigate('/');
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>➕ Add Playlist</h2>

      <h4>🔗 Add by URL</h4>
      <input
        type="text"
        placeholder="Enter M3U or JSON URL"
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        style={{ width: '100%', marginBottom: 10 }}
      />
      <button onClick={handleAddUrl}>Add URL</button>

      <hr style={{ margin: '20px 0' }} />

      <h4>📁 Select File</h4>
      <input type="file" accept=".m3u,.json" onChange={handleFile} />

      <hr style={{ margin: '20px 0' }} />

      <h4>🔐 Xtream Codes Login</h4>
      <input
        type="text"
        placeholder="Host (e.g., http://example.com)"
        value={xtream.host}
        onChange={(e) => setXtream({ ...xtream, host: e.target.value })}
        style={{ width: '100%', marginBottom: 5 }}
      />
      <input
        type="text"
        placeholder="Username"
        value={xtream.username}
        onChange={(e) => setXtream({ ...xtream, username: e.target.value })}
        style={{ width: '100%', marginBottom: 5 }}
      />
      <input
        type="password"
        placeholder="Password"
        value={xtream.password}
        onChange={(e) => setXtream({ ...xtream, password: e.target.value })}
        style={{ width: '100%', marginBottom: 10 }}
      />
      <button onClick={handleXtream}>Add Xtream</button>
    </div>
  );
}

export default AddPlaylist;
